// src/index.js
import React from "react";
import ReactDOM from "react-dom/client"; // <--- CHANGE 1: Import from 'client'
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { ToastProvider } from "react-toast-notifications";

import store from "./app/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import CustomToastContainer from "./components/CustomToastContainer";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "./index.css";

let persistor = persistStore(store);

// CHANGE 2: Use createRoot instead of ReactDOM.render
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider
          autoDismiss
          autoDismissTimeout={4000}
          placement="top-center"
          components={{ ToastContainer: CustomToastContainer }}
        >
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ToastProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
